import { PropsWithChildren, createContext, useContext } from 'react';

import { useCart } from './cart.hook';

type CartContext = ReturnType<typeof useCart>;

export const CartContext = createContext<CartContext | null>(null);

export const CartProvider = ({ children }: PropsWithChildren) => {
    const cart = useCart();

    return <CartContext.Provider value={cart}>{children}</CartContext.Provider>;
};

CartProvider.displayName = 'CartProvider';

export const useCartContext = () => {
    const context = useContext(CartContext);

    if (!context) {
        throw new Error('useCartContext must be used within a CartProvider');
    }

    return context;
};
